import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import posthog from 'posthog-js';
import { Capacitor } from '@capacitor/core';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

if ('serviceWorker' in navigator && !Capacitor.isNativePlatform()) {
  navigator.serviceWorker
    .register('/ngsw-worker.js')
    .then((reg) => console.log('Service Worker registered', reg))
    .catch((err) => {
      console.error('Service Worker registration failed', err);
      posthog.captureException(err, {
        context: 'Service Worker Registration',
        failed_url: '/ngsw-worker.js',
      });
    });
}
